import { GlobalContext } from 'contexts/Global'
import { useContext, useEffect } from 'react'
import { api } from 'services/api'
import { getParams, getPathName } from 'utils/helpers'
import { loggerInfo } from 'utils/infoLogs'

export const useWrapper = () => {
	const {
		setGlobalLoading,
		setCampaignExpired,
		setGlobalError,
		setCompanySurvey,
	} = useContext<any>(GlobalContext)

	const getToken = async () => {
		const { token } = await getParams()

		return token
	}

	const fetchSurvey = async () => {
		const token = await getToken()
		if (token) {
			setGlobalLoading(true)
			try {
				const { data } = await api.get('/campaign-answers')
				setCompanySurvey({ ...data.content })
			} catch (error: any) {
				const errors = error.response?.data?.errors
				if (
					errors &&
					errors.some((error: any) => error.code === 'INACTIVE_CAMPAIGN')
				)
					return setCampaignExpired(true)
				loggerInfo({
					data: error,
					context: 'survey',
					location: 'fetchSurvey',
				})
				setGlobalError(true)
			} finally {
				setGlobalLoading(false)
			}
		}
	}

	const fetchOptions: any = {
		cuestionario: fetchSurvey,
	}

	const getAvailableRoutes = () => {
		const pathname = getPathName()
		fetchOptions[pathname] && fetchOptions[pathname]()
	}

	useEffect(() => {
		getAvailableRoutes()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
}
